module.exports = __webpack_public_path__ + "img/survey-form.518aa8d4.svg";